

import logo from './logo.svg';
import './App.css';
import { useEffect, useState } from 'react';
import { Button, Modal, Input, message } from 'antd';
import { postData } from './FetchAPI';
import { Avatar, Card } from 'antd';
import { LoadingOutlined, PlusOutlined, ExportOutlined } from '@ant-design/icons';
import { Breadcrumb, Layout, Menu, theme } from 'antd';
import { Col, Divider, Row } from 'antd';
import { Table } from 'antd';
import { Document, Page } from 'react-pdf';
import { useMatch, useNavigate } from 'react-router';
import { Upload } from 'antd';
import { CoffeeOutlined } from '@ant-design/icons';
import { Editor } from '@tinymce/tinymce-react';
import eggInPanImg from './assets/egg-in-pan.png';
const { Header, Content, Sider } = Layout;
const { TextArea } = Input;
const { Meta } = Card;
const { Column } = Table;

const getDomain = (url) => url.replace(/^https?:\/\//, '').replace(/^www\./, '').split('/')[0];

function Recipe(props) {

  const navigate = useNavigate();

  const {
    token: { colorBgContainer, colorPrimaryActive },
  } = theme.useToken();

  const [bump, setBump] = useState(0);
  const [recipe, setRecipe] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);
  const [reviewText, setReviewText] = useState(null);

  const [currentUser, setCurrentUser] = useState(null);

  const recipe_id = useMatch('recipes/:recipe_id').params.recipe_id;

  // These are used for Image upload
  const imageUrl = null;
  const loading = false;
  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload an image</div>
    </div>
  );


  useEffect(() => {
    const loginPromise = fetch('/api/login/');
    loginPromise.then(response => {
        return response.json();
      }).then(loggedInUser => {
        setCurrentUser(loggedInUser["username"])
      });
  }, []);


  
  useEffect(() => {
    const recipePromise = fetch(`/api/recipes/${recipe_id}`);
    recipePromise.then(response => {
        return response.json();
      }).then(recipes => {
        setRecipe(recipes)
      });
  }, [bump]);

  useEffect(() => {
    const reviewsPromise = fetch(`/api/reviews/?recipe_id=${recipe_id}`);
    reviewsPromise.then(response => {
        return response.json();
      }).then(recipes => {
        setReviews(recipes)
      });
  }, [bump]);

  const showReviewModal = () => { 
    setIsReviewModalOpen(true);
  };

  const handleReviewModalOk = async (data) => {
    setIsReviewModalOpen(false);
    await postData('/api/reviews/', {recipe:recipe_id, review: reviewText});
    setBump(bump+1)
    message.success("Review Added", 8)
  };

  const handleReviewModalCancel = () => {
    setIsReviewModalOpen(false);
  };


  return (
    <Layout>
      <Header style={{display: 'flex', alignItems: 'center' }}>
        <div className="brand">🍲 Fam Cooking</div>
        <Menu theme="dark" mode="horizontal" selectedKeys={['1']} style={{flex: 1, minWidth: 0}}>
            <Menu.Item key="1" onClick={() => navigate(`/recipes/`)}>Recipes</Menu.Item>
            <Menu.Item key="2" onClick={() => navigate(`/timeline/`)}>Timeline</Menu.Item>
            <Menu.Item key="3" onClick={() => navigate(`/users/`)}>Users</Menu.Item>
        </Menu>
      </Header>
      <Layout style={{minHeight: '800px'}}>
      {/* <Modal title="Add Recipe" open={isRecipeModalOpen} onOk={handleRecipeModalOk} onCancel={handleRecipeModalCancel}>
          <Input placeholder="URL" onChange={e => setUrl(e.target.value)} />
        </Modal> */}
        <Modal
          title={`Reviewing: ${recipe.title || ''}`}
          open={isReviewModalOpen}
          onOk={handleReviewModalOk}
          onCancel={handleReviewModalCancel}
          okText="Post Review"
        >
          <p className="modal-subtitle">How'd it turn out? Share what you thought, any tweaks you made, or tips for next time.</p>
          {!currentUser && (<div className="modal-warning">Please <a href="/users/">log in</a> to continue.</div>)}
          {currentUser && (<TextArea rows={4} placeholder="Write your review..." onChange={e => setReviewText(e.target.value)} />)}
        </Modal>

        <Layout className="page-shell">
        {/* <h3>{currentUser && `Hello ${currentUser}!`}</h3> */}
          <Content
            className="page-content"
            style={{
              margin: 0,
              minHeight: 280,
              background: colorBgContainer,
            }}
          >
          <Row gutter={[24, 24]}>
            <Col xs={24} md={12}>
          {recipe && (
            <div>

              <h1 className="recipe-title">
                {recipe.url ? (
                  <a target="_blank" rel="noreferrer" href={recipe.url} className="recipe-title-link">
                    {recipe.title}
                    <ExportOutlined className="recipe-title-link-icon" aria-hidden="true" />
                  </a>
                ) : recipe.title}
              </h1>
              {recipe.url && (
                <div className="recipe-source">View original recipe at {getDomain(recipe.url)}</div>
              )}
              <h3 className="recipe-subtitle">{`Submitted by ${recipe?.submitter?.username}`}</h3>
              <div style={{width: "100%", textAlign: "center"}}>
              {recipe.top_image && (<img className="recipe-hero-img" alt={recipe.title} src={recipe.top_image} />)}
              {!recipe.top_image && (
                    <Upload
                    name="avatar"
                    listType="picture-card"
                    className="avatar-uploader"
                    showUploadList={false}
                    action={`/api/recipe-top-image/${recipe.id}`}
                    onChange={() => setBump(bump+1)}
                  >
                    {imageUrl ? <img src={imageUrl} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                  </Upload>

              )}
              </div>
            </div>
            )}

            <div className="cook-cta">
              <img className="cook-cta-icon" src={eggInPanImg} alt="" />
              <div>
                <div className="cook-cta-title">Did you cook this recipe?</div>
                <div className="cook-cta-subtitle">Log it and leave a review!</div>
              </div>
              <Button type="primary" onClick={showReviewModal}>I cooked this!</Button>
            </div>

          {reviews.map((review => {
            return <div><Card
            extra={review.created_date_ET}
            style={{ maxWidth: "800px", margin: '20px' }}
            title={<p>{review?.submitter?.username} cooked <b><a href={`/recipes/${review.recipe.id}/`}>{review.recipe.title}</a></b></p>}
          >
            <Meta
            title={<div style={{overflow: "visible", whiteSpace: "normal"}}>{`"${review.review}"`}</div>}
            description={`Reviewed by ${review.submitter.username}`}
            avatar={<Avatar size={64} src={review.submitter.avatar_png || `https://api.dicebear.com/6.x/bottts/svg?seed=${review.submitter.username}`} />}
            />
          </Card></div>
        }))}
            </Col>
            <Col xs={24} md={12} style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
              {recipe.png_count && (
                <>
                {[...Array(recipe.png_count).keys()].map((i) =>  (
                    <img className="recipe-page-img" alt={`${recipe.title} - page ${i + 1}`} src={`${recipe.png_base_link}_${i+1}.png`} />
                ))}
                </>
              )}
              {recipe.recipe_text_html && (
                <Editor 
                style={{marginLeft: "20px", marginRight: "20px"}}
                init={{
                  menubar: false,
                  toolbar: false,
                  height: "1000px",
                  width: "100%",
                }}
                disabled={true}
                initialValue={recipe.recipe_text_html} 
                apiKey="yeihiqwyp69vo8jiyufbpp2w2x49cvxzqa0txzprorzln1zh" 
                />  
              )}
            </Col>
            </Row>
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
}

export default Recipe;
